import React, { useState } from "react";
import QuoteRequestModal from "./QuoteRequestModal";

// The body under a page banner, laid out like a Service detail page: title, description, rich-text
// content and an optional button on the left, a square image on the right. Managed in the admin
// under Pages > (page) > Body. Renders nothing until the admin adds content or an image.
export default function PageBody({ content, pageTitle }) {
  const [showQuote, setShowQuote] = useState(false);
  if (!content || !(content.body_content || content.body_image)) return null;

  return (
    <>
      <section className="relative bg-navy text-white py-12 md:py-16">
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <div className={`grid gap-12 items-start ${content.body_image ? "md:grid-cols-[60%_40%]" : ""}`}>
            <div>
              <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight">{content.tagline}</h2>
              {content.description && (
                <p className="mt-4 text-lg text-gray-300">{content.description}</p>
              )}

              {content.body_content && (
                <div
                  className="mt-8 text-gray-300 leading-relaxed [&_h1]:text-2xl [&_h1]:font-bold [&_h1]:text-white [&_h1]:mt-8 [&_h1]:mb-3 [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-white [&_h2]:mt-8 [&_h2]:mb-3 [&_p]:mb-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:mb-3 [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:mb-3 [&_li]:mb-1 [&_a]:text-accent-light [&_strong]:text-white"
                  dangerouslySetInnerHTML={{ __html: content.body_content }}
                />
              )}

              {content.body_button_text && (
                <button
                  onClick={() => setShowQuote(true)}
                  className="mt-8 px-6 py-3 rounded-full bg-brand-gradient text-white font-semibold shadow-md shadow-accent/20"
                >
                  {content.body_button_text}
                </button>
              )}
            </div>

            {content.body_image && (
              <div className="md:sticky md:top-24">
                <div className="relative rounded-xl overflow-hidden bg-navy-dark border border-accent-light/25 shadow-[0_0_25px_rgba(34,211,238,0.2)]">
                  <img src={content.body_image} alt={pageTitle} className="w-full aspect-square object-cover bg-navy" />
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {showQuote && <QuoteRequestModal serviceTitle={pageTitle} onClose={() => setShowQuote(false)} />}
    </>
  );
}
